// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import "mdb-calendar/lib/main.css"
import "@/plugins"
import "@/assets/css/custom.css"

// toast message
import Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

// Sync router with store
import { sync, unsync } from 'vuex-router-sync'

Vue.config.productionTip = false

// Sync store with router
sync(store, router)

// Configure the Router Gaurd
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/loggedIn']) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters['auth/loggedIn']) {
      next({
        path: '/Zimmerübersicht'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
  components: { App },
  destroyed () {
    unsync()
  },
}).$mount('#app')


